import { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { useSandboxCreateUser } from '@/services/mutations/sandbox';
import {
	SandboxField,
	SandboxModal,
	SandboxNotice,
	sandboxInputClass,
} from './SandboxModal';

interface Props {
	scenarioId: string;
	catalog: Sandbox.Catalog;
	isOpen: boolean;
	onClose: () => void;
}

/** Cadastro de usuário de teste: tudo opcional, o backend gera o que faltar. */
const SandboxUserModal = ({ scenarioId, catalog, isOpen, onClose }: Props) => {
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [verified, setVerified] = useState(true);

	const reset = () => {
		setFirstName('');
		setLastName('');
		setEmail('');
		setPassword('');
		setVerified(true);
	};

	const { mutate, isPending } = useSandboxCreateUser(scenarioId, () => {
		reset();
		onClose();
	});

	const submit = () => {
		mutate({
			first_name: firstName.trim() || undefined,
			last_name: lastName.trim() || undefined,
			email: email.trim() || undefined,
			password: password || undefined,
			verified_email: verified,
		});
	};

	return (
		<SandboxModal
			isOpen={isOpen}
			onClose={onClose}
			title="Criar usuário"
			description="Passa pelo mesmo cadastro do site (POST /user): valida duplicidade, vincula colaborador por CPF e dispara os e-mails de boas-vindas."
			icon={<UserPlus className="h-4 w-4" />}
			confirmText="Criar usuário"
			onConfirm={submit}
			isPending={isPending}
		>
			<div className="space-y-4 py-2">
				<SandboxNotice>
					Deixe em branco para gerar nome, e-mail (
					<code>@{catalog.email_domain}</code>), CPF válido, telefone
					e data de nascimento. Senha padrão:{' '}
					<code>{catalog.default_password}</code>.
				</SandboxNotice>
				<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
					<SandboxField label="Nome">
						<input
							className={sandboxInputClass}
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							placeholder="gerado"
						/>
					</SandboxField>
					<SandboxField label="Sobrenome">
						<input
							className={sandboxInputClass}
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							placeholder="gerado"
						/>
					</SandboxField>
					<SandboxField label="E-mail">
						<input
							className={sandboxInputClass}
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="gerado"
						/>
					</SandboxField>
					<SandboxField label="Senha">
						<input
							className={sandboxInputClass}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							placeholder={catalog.default_password}
						/>
					</SandboxField>
				</div>
				<label className="flex cursor-pointer items-center gap-3 text-sm text-stone-700">
					<input
						type="checkbox"
						checked={verified}
						onChange={(e) => setVerified(e.target.checked)}
						className="h-4 w-4 accent-stone-900"
					/>
					E-mail já verificado (pula a confirmação)
				</label>
			</div>
		</SandboxModal>
	);
};

export { SandboxUserModal };
